(function () {
  angular.module("akitabox.ui.dialogs.schedule.delete", [
    "ngMaterial",
    "akitabox.core.constants",
    "akitabox.core.services.schedule",
    "akitabox.core.toast",
    "akitabox.core.services.workOrder",
  ]);
})();
